import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

/** Quiz door: one attempt, then the verdict with the correct answer and an explanation. */
@observer
class AdventQuizDoor extends Component {
    constructor(props) {
        super(props);
        this.state = { busy: false, error: '' };
    }

    answer = async (letter) => {
        const { adventCalendarStore } = this.props.stores;
        const { day } = this.props;
        this.setState({ busy: true, error: '' });
        const response = await adventCalendarStore.answer(day, letter);
        if (response?.status !== 200) {
            this.setState({ error: response?.message || 'Could not save answer' });
        }
        this.setState({ busy: false });
    }

    render() {
        const { door = {} } = this.props;
        const { busy, error } = this.state;
        const quiz = door.content?.quiz || {};
        const answered = !!door.quizAnswered;
        const yourAnswer = door.content?.yourAnswer || '';
        return (
            <div>
                <div class='fs-5 fw-bold mb-3'>{quiz.question}</div>
                <div class='d-grid gap-2'>
                    {(quiz.options || []).map((opt) => {
                        let cls = 'btn btn-outline-primary text-start';
                        if (answered) {
                            if (opt.letter === quiz.correctAnswer) {
                                cls = 'btn btn-success text-start';
                            } else if (opt.letter === yourAnswer) {
                                cls = 'btn btn-danger text-start';
                            } else {
                                cls = 'btn btn-outline-secondary text-start';
                            }
                        }
                        return (
                            <button
                                key={`advent-quiz-${opt.letter}`}
                                type='button'
                                class={cls}
                                disabled={answered || busy}
                                onClick={() => this.answer(opt.letter)}
                            >
                                <span class='badge bg-body-secondary text-body me-2'>{opt.letter}</span>
                                {opt.text}
                            </button>
                        );
                    })}
                </div>
                {error ? <div class='alert alert-danger mt-3'>{error}</div> : null}
                {answered ? (
                    <div class={`alert mt-3 ${door.quizCorrect ? 'alert-success' : 'alert-warning'}`}>
                        <div class='fw-bold'>
                            {door.quizCorrect
                                ? <Text id='adventCalendar.quizCorrect'>Correct! 🎉 One point to you.</Text>
                                : <Text id='adventCalendar.quizWrong' fields={{ answer: quiz.correctAnswer }}>Not quite. The correct answer is {quiz.correctAnswer}.</Text>}
                        </div>
                        {quiz.explanation ? <div class='small mt-1'>{quiz.explanation}</div> : null}
                    </div>
                ) : (
                    <div class='small text-body-secondary mt-3'>
                        <Text id='adventCalendar.quizOneAttempt'>You get one attempt.</Text>
                    </div>
                )}
            </div>
        );
    }
}

export default AdventQuizDoor;
